'use client'

import { useState } from 'react'

export default function TeamLogo({
  src,
  alt,
  size = 22,
}: {
  src: string | null | undefined
  alt: string
  size?: number
}) {
  const [failed, setFailed] = useState(false)
  if (!src || failed) {
    return (
      <span
        className="inline-flex shrink-0 items-center justify-center rounded-full bg-gray-100 text-[10px] font-bold text-gray-400 dark:bg-slate-800 dark:text-slate-500"
        style={{ width: size, height: size }}
        aria-hidden
      >
        {alt.slice(0, 1).toUpperCase()}
      </span>
    )
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      className="shrink-0 object-contain"
      style={{ width: size, height: size }}
      onError={() => setFailed(true)}
    />
  )
}
